
<div class="collection-stats-view">
  <empty-state
    v-if="showEmptyState"
    icon="analytics"
    title="You don't have any cards in this collection!"
    description="We calculate statistical updates to your collection at the end of each day after you add cards."
  />

  <template v-else>
    <graph-overview
      :stats="collectionStats.valueStats"
      :graph-values="[collectionStats.valueGraph, collectionStats.investmentGraph]"
      :zoom.sync="zoom"
      :scale.sync="scale"
      :empty-graph-text="emptyGraphText"
    />

    <div class="breakdowns">
      <pie-graph
        v-if="playerLabels.length"
        title="Player Breakdown"
        :labels="playerLabels"
        :datasets="playerDatasets"
      />

      <pie-graph
        v-if="categoryLabels.length"
        title="Category Breakdown"
        :labels="categoryLabels"
        :datasets="categoryDatasets"
      />
    </div>

    <div v-if="collectionStats.soldStats.length" class="sold-stats">
      <h3 class="secondary-font">
        Sold Stats
      </h3>

      <div class="grid">
        <stat-item
          v-for="(stat, i) in collectionStats.soldStats"
          :key="i"
          size="large"
          :success="stat.positive"
          :error="stat.negative"
          :label="stat.label"
          :value="stat.value"
        />
      </div>
    </div>
  </template>
</div>
